import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { UrlDataProvider } from "@/components/providers/UrlDataProvider.js";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryDatasetAsTable',
    props: {
        historyDatasetId: null,
        compact: { type: Boolean, default: false },
        showColumnHeaders: { type: Boolean, default: true },
        title: { default: undefined },
        footer: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const itemUrl = computed(() => {
            return `/api/datasets/${props.historyDatasetId}/get_content_as_text`;
        });
        const metaUrl = computed(() => {
            return `/api/datasets/${props.historyDatasetId}`;
        });
        const expanded = false;
        const contentClass = computed(() => {
            if (expanded) {
                return "embedded-dataset-expanded";
            }
            else {
                return "embedded-dataset";
            }
        });
        function getFields(metaData) {
            const fields = [];
            const columnNames = metaData.metadata_column_names || [];
            const columnCount = metaData.metadata_columns;
            for (let i = 0; i < columnCount; i++) {
                fields.push({
                    key: `${i}`,
                    label: columnNames[i] || i,
                    sortable: true,
                });
            }
            return fields;
        }
        function getItems(textData, metaData) {
            const tableData = [];
            const delimiter = metaData.metadata_delimiter || "\t";
            const comments = metaData.metadata_comment_lines || 0;
            const lines = textData.split("\n");
            lines.forEach((line, i) => {
                if (i >= comments) {
                    const tabs = line.split(delimiter);
                    const rowData = [];
                    let hasData = false;
                    tabs.forEach((cellData, j) => {
                        const cellDataTrimmed = cellData.trim();
                        if (cellDataTrimmed) {
                            hasData = true;
                        }
                        rowData[j] = cellDataTrimmed;
                    });
                    if (hasData) {
                        tableData.push(rowData);
                    }
                }
            });
            return tableData;
        }
        return { __sfc: true, props, itemUrl, metaUrl, expanded, contentClass, getFields, getItems, UrlDataProvider, LoadingSpan };
    }
});
